import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PurIndentMasterCreateRequestDTO,
  PurIndentMasterUpdateRequestDTO,
  PurIndentMasterDeleteRequestDTO,
  PurIndentMasterReadByIdRequestDTO,
  PurIndentMasterDTO,
  PurIndentMasterList,
  PurIndentMasterSearchByIndentNoRequestDTO,
  PurIndentMasterGetAvailableIndentRequestDTO,
  PurIndentMasterGetVendorPendingForPORequestDTO,
  PurIndentMasterReadByTenantIdRequestDTO,
  PurIndentMasterReadByMasterIdRequestDTO
} from './indent-master.interface';

import {
IndentMaster_Create,
IndentMaster_Update,
IndentMaster_Delete,
IndentMaster_ReadAll,
IndentMaster_ReadById,
IndentMaster_SearchByPurIndentNo,
IndentMaster_GetAvailableIndent,
IndentMaster_GetVendorPendingForPO,
IndentMaster_ReadByTenantId,
IndentMaster_ReadByMasterId,
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class IndentMasterService {

  constructor() { }

  http = inject(HttpClient);

  IndentMaster_Create(data: PurIndentMasterCreateRequestDTO): Observable<PurIndentMasterDTO> {
    return this.http.post<PurIndentMasterDTO>(IndentMaster_Create, data);
  }

  IndentMaster_Update(data: PurIndentMasterUpdateRequestDTO): Observable<PurIndentMasterDTO> {
    return this.http.post<PurIndentMasterDTO>(IndentMaster_Update, data);
  }

  IndentMaster_Delete(data: PurIndentMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(IndentMaster_Delete, data);
  }

  IndentMaster_ReadAll(): Observable<PurIndentMasterList> {
    return this.http.get<PurIndentMasterList>(IndentMaster_ReadAll);
  }

  IndentMaster_ReadById(data: PurIndentMasterReadByIdRequestDTO): Observable<PurIndentMasterDTO> {
    return this.http.post<PurIndentMasterDTO>(IndentMaster_ReadById, data);
  }

  IndentMaster_ReadByTenantId(data: PurIndentMasterReadByTenantIdRequestDTO): Observable<PurIndentMasterList> {
    return this.http.post<PurIndentMasterList>(IndentMaster_ReadByTenantId, data);
  }

  IndentMaster_SearchByPurIndentNo(data:PurIndentMasterSearchByIndentNoRequestDTO): Observable<PurIndentMasterList> {
    return this.http.post<PurIndentMasterList>(IndentMaster_SearchByPurIndentNo, data);
  }

  IndentMaster_GetAvailableIndent(data:PurIndentMasterGetAvailableIndentRequestDTO): Observable<PurIndentMasterList> {
    return this.http.post<PurIndentMasterList>(IndentMaster_GetAvailableIndent, data);
  }

  IndentMaster_GetVendorPendingForPO(data:PurIndentMasterGetVendorPendingForPORequestDTO): Observable<PurIndentMasterList> {
    return this.http.post<PurIndentMasterList>(IndentMaster_GetVendorPendingForPO, data);
  }

  IndentMaster_ReadByMasterId(data: PurIndentMasterReadByMasterIdRequestDTO): Observable<PurIndentMasterList> {
    return this.http.post<PurIndentMasterList>(IndentMaster_ReadByMasterId, data);
  }
}
